export const metadataPagePath = "/pages/product-metadata";
export const metadataSectionId = "product-metadata";
